import React from 'react';
import {toPriceStr} from '@/utils';

interface CoinItemProps {
  bonusAmount: number;
}

const CoinItem: React.FC<CoinItemProps> = ({bonusAmount}) => {
  return (
    <div className="flex flex-col items-center w-[3.375rem]">
      <div
        className="size-6 bg-full bg-no-repeat"
        style={{
          backgroundImage: `url(${require('@/assets/icons/invitation/money.webp')})`,
        }}
      />
      <span className="leading-[normal] text-[#F15802] text-[.625rem]">
        {toPriceStr(bonusAmount, {fixed: 0})}
      </span>
    </div>
  );
};

export default CoinItem;
